module.exports = __webpack_public_path__ + "img/deco_bird_purple.53e9adab.png";